// Vendor imports
const { connect } = require('react-redux')
// Entry imports
const actions = require('./actions')
const OpenInAppButton = require('./component-dumb')
const { isVisibleState } = require('./selectors')

function mapStateToProps(state) {
  return {
    initialIsVisible: isVisibleState(state)
  }
}

const mapDispatchToProps = {
  onClick: actions.openInApp,
  onDismiss: actions.dismiss
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  OpenInAppButton
)
